import { Injectable } from '@angular/core';

import { Timestamp, arrayUnion, collection, doc, setDoc, count, sum, average, getAggregateFromServer, getFirestore, deleteDoc, getDocs, where, query, documentId, getDoc, updateDoc, getDocFromCache, addDoc, orderBy, increment } from "firebase/firestore";
import moment from 'moment';
import { BehaviorSubject, Observable, defer, from, switchMap } from 'rxjs';
import { ownedCollection, withCurrentOwner } from '../../../utils/firestore-ownership';


@Injectable({
  providedIn: 'root'
})
export class CryptosService {

  private cryptos!: BehaviorSubject<any[]>;

  constructor() {
    this.cryptos = new BehaviorSubject<any[]>([])
  }

  public async selectAll(): Promise<void> {
    // console.log('CryptosService', 'selectAll')

    const cryptos:any[] = []

    const q = ownedCollection('Cryptos');
    const allDocs = await getDocs(q)
    allDocs.docs.forEach((d:any, j:any, h:any) => {
      // console.log('Doc:', d.id, 'Side:', d.data().side, j, h)
      
      const doc = { ...d.data(), id: d.id }
      cryptos.push(doc)
    })
    
    this.cryptos.next(cryptos)
  }

  getAll(): Observable<any[]> {
    console.log('CompaniesService', 'getAll')

    return defer(() => from(this.selectAll()).pipe(switchMap(() => this.cryptos.asObservable())));
  }

  async addItem(e:any):Promise<void> {
    console.log('CryptosService', 'addItem', e)

    // if(e.date != undefined)
    //   e.date = new Date(e.date.seconds).getSeconds()

    await addDoc(collection(getFirestore(), 'Cryptos'), { ...withCurrentOwner(e), created_on: Timestamp.now(), modified_on: Timestamp.now() });

    // this.cryptos.next([e, ...this.cryptos.value])
    await this.selectAll()
  }

  async delete(e:any):Promise<void>{
    console.log('CryptosService', 'delete', e.id)

    await deleteDoc(doc(getFirestore(), 'Cryptos', e.id));
    await this.selectAll();
  }

  async modify(e:any):Promise<void>{
    console.log('CryptosService', 'modify', e.id)

    await updateDoc(doc(getFirestore(), 'Cryptos', e.id), { ...withCurrentOwner(e), modified_on: Timestamp.now() });
    await this.selectAll();
  }

  async updateAttach(e: any, path: string, name: string):Promise<void> {
    console.log('CryptosService', 'updateAttach', e.id)
    
    await updateDoc(doc(getFirestore(), "Cryptos", e.id), {
      attach: increment(1),
      attachments: arrayUnion({ path, name, createdOn: Timestamp.now() })
    })
    .then(() => {
      console.log('CryptosService', 'updateAttach', e.id, 'UPDATED')
    })    
  }

}
